import React, { useState } from 'react';
import { Page, NotifyModal, ModalAlert } from 'components';
import Header from 'components/Header/Header';
import { useHistory } from 'react-router-dom';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import Api from 'services/Api';

const Models3DAdd = () => {
  const history = useHistory();

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.cooperatives?.write !== true) {
    window.location.replace('/home');
  }

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [bucketKey, setBucketKey] = useState('mecanica');
  const [uploading, setUploading] = useState(false);

  const [type, setType] = useState({ color: "", status: "" });
  const [modalShow, setModalShow] = useState(false);
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [message, setMessage] = useState("");

  const handleModalAlert = (msg) => {
    setMessage(msg);
    setShowModalAlert(true)
  }

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "red", "status": msg })
    setModalShow(true)
  }

  const handleFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    setSelectedFile(file);
    setFileName(file?.name || '');
  };

  const handleUpload = async () => {
    try {
      if (!selectedFile) {
        handleModalAlert('Selecione um arquivo para enviar.');
        return;
      }
      if (!bucketKey) {
        handleModalAlert('Informe o bucket (ex.: mecanica).');
        return;
      }
      setUploading(true);
      const formData = new FormData();
      formData.append('bucketKey', bucketKey);
      formData.append('file', selectedFile);

      // Endpoint do backend que faz upload ao Autodesk OSS
      const res = await Api.post('/api/v1/upload-autocad', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      handleAlertModalSuccess('Upload realizado com sucesso!');
      // Opcional: redirecionar para a lista após breve intervalo
      setTimeout(() => history.push('/models-3d'), 1000);
    } catch (e) {
      console.error(e);
      handleAlertModalError('Erro ao enviar arquivo.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <Page className="p-3" title="Adicionar Modelo 3D">

      <Header page={'Adicionar Modelo 3D'} />

      <ModalAlert
        message={message}
        showModalAlert={showModalAlert}
        onHide={() => setShowModalAlert(false)}
      />

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Card>
        <Card.Body>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group controlId="bucketKey">
                <Form.Label>Bucket</Form.Label>
                <Form.Control
                  type="text"
                  value={bucketKey}
                  onChange={(e) => setBucketKey(e.target.value)}
                  disabled={true}
                  placeholder="Ex.: mecanica"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group controlId="file3d">
                <Form.Label>Arquivo 3D</Form.Label>
                <Form.Control
                  type="file"
                  onChange={handleFileChange}
                  accept=".step,.stp,.dwg,.dxf,.sldprt,.sldasm,.ipt,.iam,.obj,.fbx,.rvt,.zip"
                  //disabled={permission === true ? false : true}
                />
              </Form.Group>
              {fileName && (
                <p className="mt-2 mb-0"><small>Selecionado: {fileName}</small></p>
              )}
            </Col>
            <Col md={12}>
              <Button
                variant="success"
                onClick={handleUpload}
                disabled={!selectedFile || uploading}
              >
                {uploading && (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                )}
                Enviar
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

    </Page>
  );
};

export default Models3DAdd;
